
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { Model, ModelProperty } from 'models/Model';


export class SalesCommissionViewModel extends Model<SalesCommissionViewModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'orderId', type: 'guid', languageString: 'salesCommissionView.property.orderId' },
		{ name: 'referenceNumber', type: 'number', languageString: 'salesCommissionView.property.referenceNumber' },
		{ name: 'orderLineId', type: 'guid', languageString: 'salesCommissionView.property.orderLineId' },
		{ name: 'companyId', type: 'guid', languageString: 'salesCommissionView.property.companyId' },
		{ name: 'sellerId', type: 'guid', languageString: 'salesCommissionView.property.sellerId' },
		{ name: 'salesTeamId', type: 'guid', languageString: 'salesCommissionView.property.salesTeamId' },
		{ name: 'created', type: 'Date', languageString: 'salesCommissionView.property.created', isHidden: true },
		{ name: 'signDate', type: 'Date', languageString: 'salesCommissionView.property.signDate' },
		{ name: 'withholdCommission', type: 'boolean', languageString: 'salesCommissionView.property.withholdCommission' },
		{ name: 'companyHadActivePlans', type: 'boolean', languageString: 'salesCommissionView.property.companyHadActivePlans' },
		{ name: 'approved', type: 'number', languageString: 'salesCommissionView.property.approved' },
		{ name: 'productVariantId', type: 'guid', languageString: 'salesCommissionView.property.productVariantId' },
		{ name: 'productName', type: 'string', languageString: 'salesCommissionView.property.productName' },
		{ name: 'variantName', type: 'string', languageString: 'salesCommissionView.property.variantName' },
		{ name: 'quantity', type: 'number', languageString: 'salesCommissionView.property.quantity' },
		{ name: 'unitPrice', type: 'number', languageString: 'salesCommissionView.property.unitPrice' },
		{ name: 'totalPrice', type: 'number', languageString: 'salesCommissionView.property.totalPrice' },
		{ name: 'startupAmount', type: 'number', languageString: 'salesCommissionView.property.startupAmount' },
		{ name: 'startupInstallments', type: 'number', languageString: 'salesCommissionView.property.startupInstallments' },
		{ name: 'paymentInterval', type: 'number', languageString: 'salesCommissionView.property.paymentInterval' },
		{ name: 'period', type: 'number', languageString: 'salesCommissionView.property.period' },
		{ name: 'orderCancelled', type: 'number', languageString: 'salesCommissionView.property.orderCancelled' },
		{ name: 'orderWarning', type: 'number', languageString: 'salesCommissionView.property.orderWarning' },
		{ name: 'cancelledStatus', type: 'string', languageString: 'salesCommissionView.property.cancelledStatus' },
		{ name: 'acvExtend', type: 'number', languageString: 'salesCommissionView.property.acvExtend' },
		{ name: 'acvIncrease', type: 'number', languageString: 'salesCommissionView.property.acvIncrease' },
		{ name: 'upFront', type: 'number', languageString: 'salesCommissionView.property.upFront' },
		{ name: 'oneOffAmount', type: 'number', languageString: 'salesCommissionView.property.oneOffAmount' },
		{ name: 'accumulatedSalesValue', type: 'number', languageString: 'salesCommissionView.property.accumulatedSalesValue' },
		{ name: 'acvExtendCommissionEnabled', type: 'boolean', languageString: 'salesCommissionView.property.acvExtendCommissionEnabled' },
		{ name: 'acvIncreaseCommissionEnabled', type: 'boolean', languageString: 'salesCommissionView.property.acvIncreaseCommissionEnabled' },
		{ name: 'upFrontCommissionEnabled', type: 'boolean', languageString: 'salesCommissionView.property.upFrontCommissionEnabled' },
		{ name: 'oneOffCommissionEnabled', type: 'boolean', languageString: 'salesCommissionView.property.oneOffCommissionEnabled' },
		{ name: 'acvIncreasePartitions', type: 'number', languageString: 'salesCommissionView.property.acvIncreasePartitions' },
		{ name: 'accumulatedCommissionValue', type: 'number', languageString: 'salesCommissionView.property.accumulatedCommissionValue' },
		{ name: 'discount', type: 'number', languageString: 'salesCommissionView.property.discount' }
	];
	[key: string]: any;
	
	public orderId?: string;
	public referenceNumber: number;
	public orderLineId?: string;
	public companyId?: string;
	public sellerId?: string;
	public salesTeamId?: string;
	public created?: Date;
	public signDate?: Date;
	public withholdCommission: boolean;
	public companyHadActivePlans: boolean;
	public approved: number;
	public productVariantId?: string;
	public productName: string;
	public variantName: string;
	public quantity: number;
	public unitPrice?: number;
	public totalPrice: number;
	public startupAmount?: number;
	public startupInstallments?: number;
	public paymentInterval: number;
	public period: number;
	public orderCancelled: number;
	public orderWarning: number;
	public cancelledStatus: string;
	public acvExtend: number;
	public acvIncrease: number;
	public upFront: number;
	public oneOffAmount: number;
	public accumulatedSalesValue?: number;
	public acvExtendCommissionEnabled: boolean;
	public acvIncreaseCommissionEnabled: boolean;
	public upFrontCommissionEnabled: boolean;
	public oneOffCommissionEnabled: boolean;
	public acvIncreasePartitions?: number;
	public accumulatedCommissionValue?: number;
	public discount?: number;
    
	constructor(){
		super();
		this.orderId = undefined;
		this.referenceNumber = 0;
		this.orderLineId = undefined;
		this.companyId = undefined;
		this.sellerId = undefined;
		this.salesTeamId = undefined;
		this.created = undefined;
		this.signDate = undefined;
		this.withholdCommission = false;
		this.companyHadActivePlans = false;
		this.approved = 0;
		this.productVariantId = undefined;
		this.productName = '';
		this.variantName = '';
		this.quantity = 0;
		this.unitPrice = undefined;
		this.totalPrice = 0;
		this.startupAmount = undefined;
		this.startupInstallments = undefined;
		this.paymentInterval = 0;
		this.period = 0;
		this.orderCancelled = 0;
		this.orderWarning = 0;
		this.cancelledStatus = '';
		this.acvExtend = 0;
		this.acvIncrease = 0;
		this.upFront = 0;
		this.oneOffAmount = 0;
		this.accumulatedSalesValue = undefined;
		this.acvExtendCommissionEnabled = false;
		this.acvIncreaseCommissionEnabled = false;
		this.upFrontCommissionEnabled = false;
		this.oneOffCommissionEnabled = false;
		this.acvIncreasePartitions = undefined;
		this.accumulatedCommissionValue = undefined;
		this.discount = undefined;
		
	}
	getProperties(){
		return SalesCommissionViewModel.classProperties;
	}
}

